import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { ModalCloseSession } from "../components/Modal/ModalCloseSession";
import { useNotificacionAnt } from "../hooks/useNotificacionAnt";
import { useVerificateToken } from "../hooks/useVerificateToken";
import { MenuSlice } from "../components/Slice/MenuSlice";
import { Version } from "../components/Version/Version";
import { useReduxUI } from "../hooks/redux/useReduxUI";

import "./inmersys.css";
import { getIsDevelopment } from "../helpers/generalHelper";

export const LayoutInmersys = () => {
    const {
        auth: { name, email },
    } = useSelector((state) => state);
    useVerificateToken(true);

    const { contextHolder } = useNotificacionAnt();
    const {
        state: { isOpenMenu, isOpenCloseSesionModal },
        toggledMenuSlice, toggledSesionModal
    } = useReduxUI();


    return (
        <div className="flex h-screen w-full">
            <aside
                className={`overflow-auto scrollbar-custom lg:h-screen fixed lg:static left-0 top-16 bottom-0 w-screen md:max-w-[240px] ${getIsDevelopment() ? "bg-orange-700" : "bg-secondary"} z-50 transition-all duration-300 ease-in-out ${isOpenMenu ? "translate-x-0 lg:max-w-[240px]" : "lg:translate-x-0 -translate-x-[100vw] lg:w-24"
                    }`}
            >
                <div className="flex flex-col justify-between gap-4 h-full">
                    <MenuSlice />
                    <Version />
                </div>
            </aside>
            <div className="w-full h-screen flex flex-col  lg:overflow-y-scroll invisible-scrollbar lg:max-h-screen">
                <header className={`z-20 h-16 w-full p-4 ${getIsDevelopment() ? "bg-orange-700" : "bg-secondary"} text-white flex justify-start items-center fixed  top-0`}>
                    <button
                        type="button"
                        className="pr-4"
                        onClick={() => {
                            toggledMenuSlice(!isOpenMenu);
                        }}
                    >
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M3.75 6.75H20.25M3.75 12H20.25M3.75 17.25H20.25"
                                stroke="white"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </button>
                    <h1>
                        Bienvenido: {name}, {email}
                    </h1>
                </header>
                <main className="mt-16 grow h-full ">
                    {contextHolder}
                    <Outlet />
                </main>
            </div>
            {isOpenCloseSesionModal && <ModalCloseSession setOpenModal={toggledSesionModal} />}
        </div>
    );
};
